<template>
  <div class="workers-selection">
    <ValidationProvider
      v-slot="{ errors }"
      name="selectedWorkers"
      rules="required"
    >
      <Select
        autocomplete
        :error-messages="showValidationErrors ? errors : ''"
        :value="selectedWorkers"
        @input="handleSelectedWorkers($event)"
        :disabled="isLoading"
        :items="formattedWorkers"
        item-text="fullName"
        item-value="id"
        :menuProps="{
          openOnClick: preventSelecting,
          closeOnContentClick: preventSelecting
        }"
        ref="autocomplete"
        chips
        small-chips
        multiple
        :loading="isLoading"
      >
        <template v-slot:selection="{ data }">
          <v-chip
            close
            @click:close="unselectWorker(data.item)"
            class="selected-worker-chip"
          >
            <v-icon>mdi-account</v-icon>
            {{ data.item.fullName }}
          </v-chip>
        </template>
        <template v-slot:item="{ item }">
          <StatusItem class="user-select-item">
            <template v-slot:icon><v-icon>mdi-account</v-icon></template>
            {{ item.fullName }}
          </StatusItem>
        </template>
      </Select>
    </ValidationProvider>
  </div>
</template>

<script>
import StatusItem from "@/components/common/StatusItem";
import { ValidationProvider } from "vee-validate";
import Select from "@/components/common/Select";
import { getFullName } from "@/utils/users";
import { map } from "lodash";

export default {
  name: "WorkersSelection",
  components: { StatusItem, ValidationProvider, Select },
  computed: {
    formattedWorkers() {
      return this.isCandidates
        ? this.workers
        : map(this.workers, worker => ({
            ...worker,
            fullName: getFullName(worker)
          }));
    }
  },
  props: {
    workers: {
      type: Array,
      required: true
    },
    selectedWorkers: Array,
    preventSelecting: {
      type: Boolean,
      required: false
    },
    showValidationErrors: {
      type: Boolean,
      required: false
    },
    isLoading: Boolean,
    isCandidates: Boolean
  },
  methods: {
    handleSelectedWorkers(selectedWorkers) {
      this.$refs.autocomplete.isMenuActive = true;
      this.$emit("handleSelectedWorkers", selectedWorkers);
    },
    unselectWorker(currentWorker) {
      this.$emit("unselectWorker", currentWorker);
    }
  }
};
</script>

<style lang="scss">
.workers-selection {
  .v-input__control .v-input__slot {
    height: auto !important;
  }

  .selected-worker-chip {
    background: $selected !important;

    span {
      color: white;
      font-weight: bold;
    }

    .v-icon {
      margin-right: 0.5rem;
      color: white;
    }
  }
}
</style>
